import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
Vue.use(VueRouter)
import routes from './router/index.js'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import './plugins/firebase';
import "./plugins/vuefire";

import titleMixin from './components/utilities/titleMixin'
Vue.mixin(titleMixin)

import {
  store
} from '../store/store'

Vue.config.productionTip = false

const router = new VueRouter({
  mode: 'history',
  routes
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')